"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISubscriptionType = void 0;
var ISubscriptionType;
(function (ISubscriptionType) {
    ISubscriptionType["Free"] = "free";
    ISubscriptionType["Premium"] = "premium";
    ISubscriptionType["CoachPlus"] = "coach-plus";
})(ISubscriptionType || (exports.ISubscriptionType = ISubscriptionType = {}));
//# sourceMappingURL=subscription-type.js.map